import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { faqData } from '../data/mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              Perguntas Frequentes
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Dúvidas Comuns
            </h2>
            <p className="text-xl text-gray-600">
              Respondemos as principais questões sobre energia solar
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="bg-gray-50 border border-gray-200 rounded-2xl px-6 hover:border-orange-500 transition-colors duration-300"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* CTA Box */}
          <div className="mt-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-10 text-center shadow-2xl">
            <h3 className="text-3xl font-bold text-white mb-4">
              Ainda tem dúvidas?
            </h3>
            <p className="text-xl text-orange-100 mb-6">
              Nossa equipe está pronta para te ajudar com qualquer questão
            </p>
            {/* LINK DO WHATSAPP - Edite o link abaixo */}
            <button
              onClick={() => window.open('https://wa.me/5538997523325?text=Ol%C3%A1!%20Tenho%20algumas%20d%C3%BAvidas%20sobre%20energia%20solar.', '_blank')}
              className="bg-white text-orange-600 px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Falar no WhatsApp
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
